import config from '../../config';
import {
  getThoughtSpotToken,
} from '../../common/authentication';
import { jittoDashboardList } from './jittoEmbed';

const PINBOARDS = 0;
const USER_SESSION = 1;
const FAVORITES = 2;

export default function dashboardsMiddleware(store) {
  return (next) => (action) => {
    switch (action.type) {
      case 'dashboards/getdashboards':
        // Jitto Answer: the list is the dashboards this app embeds.
        if (config.jittoEmbedActiveFlag) {
          store.dispatch({
            type: 'dashboards/update',
            payload: { dashboards: jittoDashboardList(config.dashboards), status: 'loaded' },
          });
          break;
        }
        store.dispatch({
          type: 'dashboards/update',
          payload: { status: 'loading' },
        });
        getThoughtSpotToken().then((result) => {
          tsLogin(result.thoughtSpotToken, result.userName)
            .then(() => Promise.all([getPinboardList(), getSessionInfo(),getPinboardFavorites()]))
            .then((results) => {
              const userGuid = results[USER_SESSION].userGUID;
              const dashboards = (results[PINBOARDS] || []).map(element => {
                return {
                    id: element.id,
                    name: element.name,
                    authorName : element.authorName,
                    created:    element.created,
                    modified:   element.modified,
                    isFavorite: (results[FAVORITES] || [] ).filter(p => p.id == element.id).length > 0
                } 
              });
              store.dispatch({
                type: 'dashboards/update',
                payload: { dashboards, status: 'loaded' },
              });
            });
        });
        break;
      default:
        return next(action);
    }
  };
}

function tsLogin(token, userName) {
  const url = `${config.thoughtSpotHost}/callosum/v1/session/login/token?username=${encodeURIComponent(userName)}&auth_token=${token}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'X-Requested-By': 'ThoughtSpot',
    },
    credentials: 'include',
  });
}

function getSessionInfo() {
  const url = `${config.thoughtSpotHost}/callosum/v1/session/info`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'X-Requested-By': 'ThoughtSpot',
    },
    credentials: 'include',
  }).then((response) => response.json());
}

function getPinboardFavorites() {
  const type = 'PINBOARD_ANSWER_BOOK';
  const batchSize = -1;
  const url = `${config.thoughtSpotHost}/callosum/v1/tspublic/v1/metadata/listobjectheaders?type=${type}&batchsize=${batchSize}&category=FAVORITE`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'X-Requested-By': 'ThoughtSpot',
    },
    credentials: 'include',
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((error) => {
      console.error('Unable to get the pinboard list: ' + error);
    });
}

function getPinboardList() {
    const type = 'PINBOARD_ANSWER_BOOK';
    const batchSize = -1;
    const url = `${config.thoughtSpotHost}/callosum/v1/tspublic/v1/metadata/list?type=${type}&batchsize=${batchSize}`;
  
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-By': 'ThoughtSpot',
      },
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => data?.headers)
      .catch((error) => {
        console.error('Unable to get the pinboard list: ' + error);
      });
}
  
  